import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { ChakraProvider } from '@chakra-ui/react'
import { BrowserRouter } from 'react-router-dom';
import { AuthContextProvider } from './context/auth';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
     <AuthContextProvider>
      <ChakraProvider>
          <App/>
      </ChakraProvider>
     </AuthContextProvider>
     </BrowserRouter>
  </React.StrictMode>
);